if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      constructor() {
        super();

        this.stickyBar = this;
        this.addBtnWrap = this.querySelector('.sticky-atc-bar__add-btn-wrap');
        this.addBtn = this.querySelector('.sticky-atc-bar__add-btn');
        this.btnText = this.querySelector('.sticky-atc-bar__btn-text');
        this.successBlock = this.querySelector('.sticky-atc-bar__success');
        this.spacer = document.querySelector('.sticky-atc-bar-spacer');
        this.variantIdInput = this.querySelector('[name="sticky-variant-id"]');
        this.footerInView = false;
        this.chatSyncAttempts = 0;
        this.boundSyncChatOffset = this.syncChatOffset.bind(this);
        this.stickyBar.setAttribute('aria-hidden', 'true');
        this.stickyBar.inert = true;

        this.originalBuyButtons = document.querySelector(
          'product-info[data-section="' + this.dataset.section + '"] .product-form__submit'
        );

        this.addBtn.addEventListener('click', this.onAddToCart.bind(this));

        this.variantChangeUnsubscribe = subscribe(
          PUB_SUB_EVENTS.variantChange,
          this.onVariantChange.bind(this)
        );

        this.initVisibility();
        this.initFooterVisibility();
        this.initChatCoordination();
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscribe) this.variantChangeUnsubscribe();
        if (this.scrollObserver) this.scrollObserver.disconnect();
        if (this.footerObserver) this.footerObserver.disconnect();
        if (this.footerLookupObserver) this.footerLookupObserver.disconnect();
        if (this.barResizeObserver) this.barResizeObserver.disconnect();
        if (this.chatSyncTimer) window.clearTimeout(this.chatSyncTimer);
        if (this.chatHost) this.chatHost.style.setProperty('--veg-shop-sticky-atc-offset', '0px');
        window.removeEventListener('resize', this.boundSyncChatOffset);
        window.removeEventListener('vegenergy:chat-reveal', this.boundSyncChatOffset);
      }

      initVisibility() {
        var self = this;
        var target = this.originalBuyButtons
          || document.querySelector(
               'product-info[data-section="' + this.dataset.section + '"]'
             );
        if (!target) return;
        this.visibilityTarget = target;

        this.hasScrolled = false;
        function onFirstScroll() {
          self.hasScrolled = true;
          window.removeEventListener('scroll', onFirstScroll);
        }
        window.addEventListener('scroll', onFirstScroll, { passive: true });

        this.scrollObserver = new IntersectionObserver(
          function(entries) {
            for (var i = 0; i < entries.length; i++) {
              if (entries[i].isIntersecting) {
                self.hide();
              } else if (self.hasScrolled) {
                self.show();
              }
            }
          },
          { threshold: 0 }
        );

        this.scrollObserver.observe(target);
      }

      initFooterVisibility() {
        var self = this;

        function observeFooter() {
          var footer = document.querySelector('[data-vegenergy-sticky-zone]');
          if (!footer || footer === self.observedFooter) return false;

          if (self.footerObserver) self.footerObserver.disconnect();
          self.observedFooter = footer;
          self.footerObserver = new IntersectionObserver(
            function(entries) {
              for (var i = 0; i < entries.length; i++) {
                if (entries[i].target !== self.observedFooter) continue;

                self.footerInView = entries[i].isIntersecting;
                if (self.footerInView) {
                  self.hide();
                } else if (self.hasScrolled && self.visibilityTarget) {
                  var rect = self.visibilityTarget.getBoundingClientRect();
                  if (rect.bottom <= 0 || rect.top >= window.innerHeight) self.show();
                }
              }
            },
            { threshold: 0 }
          );
          self.footerObserver.observe(footer);
          return true;
        }

        if (observeFooter()) return;

        this.footerLookupObserver = new MutationObserver(function() {
          if (observeFooter() && self.footerLookupObserver) {
            self.footerLookupObserver.disconnect();
            self.footerLookupObserver = null;
          }
        });
        this.footerLookupObserver.observe(document.body, { childList: true, subtree: true });
      }

      initChatCoordination() {
        var self = this;

        if ('ResizeObserver' in window) {
          this.barResizeObserver = new ResizeObserver(function() {
            self.syncChatOffset();
          });
          this.barResizeObserver.observe(this.stickyBar);
        }

        window.addEventListener('resize', this.boundSyncChatOffset, { passive: true });
        window.addEventListener('vegenergy:chat-reveal', this.boundSyncChatOffset);
        this.syncChatOffset();
      }

      ensureChatOffsetStyle() {
        var host = document.getElementById('vegenergy-chat-widget');
        var root = host && host.shadowRoot;
        if (!root) return false;

        if (!root.querySelector('[data-vegenergy-sticky-cart-offset]')) {
          var style = document.createElement('style');
          style.setAttribute('data-vegenergy-sticky-cart-offset', '');
          style.textContent = [
            '.veg-chat-launcher-wrap {',
            '  translate: 0 calc(-1 * var(--veg-shop-sticky-atc-offset, 0px));',
            '  transition: translate 260ms cubic-bezier(0.22, 1, 0.36, 1) !important;',
            '}',
            '@media (prefers-reduced-motion: reduce) {',
            '  .veg-chat-launcher-wrap { transition-duration: 0.01ms !important; }',
            '}'
          ].join('\n');
          root.appendChild(style);
        }

        this.chatHost = host;
        return true;
      }

      syncChatOffset() {
        var visible = this.stickyBar.classList.contains('is-visible') && !this.footerInView;
        var offset = visible ? Math.ceil(this.stickyBar.getBoundingClientRect().height) + 16 : 0;

        document.documentElement.classList.toggle('veg-sticky-atc-visible', visible);
        document.documentElement.style.setProperty('--veg-shop-sticky-atc-offset', offset + 'px');

        if (this.ensureChatOffsetStyle()) {
          this.chatHost.style.setProperty('--veg-shop-sticky-atc-offset', offset + 'px');
          this.chatSyncAttempts = 0;
        } else if (this.chatSyncAttempts < 80 && !this.chatSyncTimer) {
          var self = this;
          this.chatSyncAttempts += 1;
          this.chatSyncTimer = window.setTimeout(function() {
            self.chatSyncTimer = null;
            self.syncChatOffset();
          }, 250);
        }

        window.dispatchEvent(
          new CustomEvent('vegenergy:sticky-cart-change', {
            detail: { visible: visible, offset: offset, footerInView: this.footerInView }
          })
        );
      }

      show() {
        if (this.footerInView) {
          this.hide();
          return;
        }

        this.stickyBar.classList.add('is-visible');
        this.stickyBar.removeAttribute('aria-hidden');
        this.stickyBar.inert = false;
        if (this.spacer) this.spacer.classList.add('is-active');
        this.syncChatOffset();
      }

      hide() {
        this.stickyBar.classList.remove('is-visible');
        this.stickyBar.setAttribute('aria-hidden', 'true');
        this.stickyBar.inert = true;
        if (this.spacer) this.spacer.classList.remove('is-active');
        this.syncChatOffset();
      }

      onVariantChange(event) {
        if (event.data && event.data.variant) {
          var variant = event.data.variant;
          this.variantIdInput.value = variant.id;

          if (variant.available) {
            this.addBtn.removeAttribute('disabled');
            this.btnText.textContent = window.variantStrings.addToCart;
          } else {
            this.addBtn.setAttribute('disabled', 'disabled');
            this.btnText.textContent = window.variantStrings.soldOut;
          }

          this.resetToAddState();
        }
      }

      onAddToCart() {
        if (this.addBtn.getAttribute('disabled') === 'disabled') return;
        if (this.addBtn.classList.contains('loading')) return;

        this.addBtn.classList.add('loading');
        var spinner = this.addBtn.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        var variantId = this.variantIdInput.value;
        var config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        var formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');
        formData.append('sections', 'cart-icon-bubble,cart-drawer');
        formData.append('sections_url', window.location.pathname);

        config.body = formData;

        var self = this;

        fetch(routes.cart_add_url, config)
          .then(function(r) {
            return r.json();
          })
          .then(function(data) {
            if (data.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'sticky-add-to-cart',
                productVariantId: variantId,
                errors: data.errors || data.description,
                message: data.message
              });
              return;
            }

            if (data.sections) {
              var sectionHtml = data.sections['cart-icon-bubble'];
              if (sectionHtml) {
                var bubbleEl = document.getElementById('cart-icon-bubble');
                if (bubbleEl) {
                  var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
                  var sec = doc.querySelector('.shopify-section');
                  if (sec) {
                    bubbleEl.innerHTML = sec.innerHTML;
                  }
                }
              }

              var drawerHtml = data.sections['cart-drawer'];
              if (drawerHtml) {
                var cartDrawerEl = document.getElementById('CartDrawer');
                if (cartDrawerEl) {
                  var drawerDoc = new DOMParser().parseFromString(drawerHtml, 'text/html');
                  var drawerSec = drawerDoc.querySelector('#CartDrawer');
                  if (drawerSec) {
                    cartDrawerEl.innerHTML = drawerSec.innerHTML;

                    var newOverlay = cartDrawerEl.querySelector('#CartDrawer-Overlay');
                    var parentDrawer = document.querySelector('cart-drawer');
                    if (newOverlay && parentDrawer) {
                      newOverlay.addEventListener('click', parentDrawer.close.bind(parentDrawer));
                    }
                  }
                }
              }
            }

            var cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
              cartDrawer.classList.remove('is-empty');
            }
            var drawerItems = document.querySelector('cart-drawer-items');
            if (drawerItems) {
              drawerItems.classList.remove('is-empty');
            }

            self.showSuccess();

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'sticky-add-to-cart',
              productVariantId: variantId,
              cartData: data
            });
          })
          .catch(function(e) {
            console.error(e);
          })
          .finally(function() {
            self.addBtn.classList.remove('loading');
            var sp = self.addBtn.querySelector('.loading__spinner');
            if (sp) sp.classList.add('hidden');
          });
      }

      showSuccess() {
        this.addBtnWrap.classList.add('is-hidden');
        this.successBlock.classList.add('is-active');
      }

      resetToAddState() {
        this.addBtnWrap.classList.remove('is-hidden');
        this.successBlock.classList.remove('is-active');
      }
    }
  );
}
